var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5372",
    "data-name": "Group 5372",
    transform: "translate(-1768.5 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    width: 50,
    height: 50,
    rx: 5,
    transform: "translate(1768.5 320)",
    fill: "#3160d4",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M32.443,23.87a1.429,1.429,0,0,1,2.014-2.029l6.129,6.143A2.857,2.857,0,0,1,41.428,30h0a2.857,2.857,0,0,1-.843,2l-6.129,6.143a1.429,1.429,0,0,1-2.014-2.029L37.946,30Z",
    transform: "translate(1763.074 381.428) rotate(-90)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqOpen);
export default __webpack_public_path__ + "static/media/faqOpen.8d3e23d2b17d744e78d83ad21c98df18.svg";
export { ForwardRef as ReactComponent };